import { useMutation } from "@apollo/client/react"; import { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import PrintIcon from '@mui/icons-material/Print';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CommentIcon from '@mui/icons-material/Comment';
import { AnularModal } from '../components/AnularModal';
import { ValidarModal } from '../components/ValidacionModal';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import columnsBase from '../constants/columns';

import MODIFICAR_VISITA from '../../../data/graphQL/mutations/ControlVisita/modificarVisita';
import moment from 'moment';
import { toast } from 'react-hot-toast';
import { DetalleAccionesModal } from '../components/DetalleAccionesModal';
import { useGetBreakpoints } from "../../../responsiveTools/breakpoints";
import { ModificarModal } from "../components/ModificarModal";

export const useGetColumns = ({ datosCabecera, reload, idTipoProfesional, handleOpenNovedadesModal, userLoggedMedicoONutri }) => {
  const { isMobile } = useGetBreakpoints();

  const navigate = useNavigate();

  const [modificarVisita] = useMutation(MODIFICAR_VISITA, {
    fetchPolicy: 'no-cache'
  });

  const handleClickVisita = (row, readOnlyParam) => {
    const auxDataState = {
      ...row,
      isNew: false,
      idTipoProfesional: datosCabecera?.idTipoProfesional,
      idFiguraProfesional: datosCabecera?.idFiguraProfesional,
      onlyView: readOnlyParam,
      visitasProgramadas: `${datosCabecera?.visitasRealizadas} / ${datosCabecera?.visitasEstimadas}`,
      periodo: datosCabecera?.fechaAsignacion,
      desdeCoordinacion: true
    };

    const route = "/misVisitas/nuevaVisita";
    //ahora en el caso de darle al modificar a una visita que ya fue clonada, lo que se hace es redirigir a 
    // la visita hija (de coordinacion) para evitar crear una nueva visita clonada sobre la misma visita original

    if (!!route && !!readOnlyParam)
      navigate(route, { state: { ...auxDataState } });
    else if ((!!row.idVisitaClone || !!row.idUsuarioModificacion) &&
      (!row?.fechaAnulacion || moment(row?.fechaModificacion).isAfter(moment(row?.fechaAnulacion)))
    ) {
      navigate(route,
        {
          state:
          {
            ...auxDataState,
            idVisita: row?.idVisitaChild || row.idVisita,
            isClone: true
          }
        }
      );
    }
    else {
      modificarVisita({ variables: { idVisita: row.idVisita } }).then((res) => {

        navigate(route, {
          state: {
            ...auxDataState,
            isClone: true,
            idVisita: res?.data?.modificacionVisita
          }
        });
      }).catch(() => toast.error('Ha ocurrido un error!'));
    }
  };

  const puedeVerNovedades = (row) => {
    return !row.estado.toLowerCase().includes('cero') && userLoggedMedicoONutri;
  }

  const actionColumn = {
    headerName: '',
    field: 'action',
    flex: 0.0005,
    width: 40,
    renderCell: (cellProps) => {
      const { row } = cellProps;

      const fechaVisita = moment(row.fechaVisita);
      const fechaAltaVisita = moment(row.fechaAlta);
      const primerDiaMesSiguiente = fechaVisita.clone().add(1, 'month').startOf('month');
      const plazoLimite = primerDiaMesSiguiente.clone().add(96, 'hours');
      const dentroDelPlazoDeModificacion = moment().diff(fechaAltaVisita, 'hours') < 48;
      const dentroDelPlazoGestion = moment().isBefore(plazoLimite);

      return <>
        <PopoverModal>
          <div className='popover-modal-content'>

            <div aria-hidden='true' onClick={() => handleClickVisita(row, true)} className='item-option clickable-option'>
              <VisibilityIcon className='edit-icon' />
              <span className='toggle-action'>Ver Visita</span>
            </div>

            <DetalleAccionesModal visita={row} />

            {("Liberada" === row.estado || "Anulada" === row.estado)
              && dentroDelPlazoDeModificacion
              && row?.idComboVisitaValorPacienteDomicilio === 5 // Paciente en Domicilio
              && (!!datosCabecera?.puedeModificar)
              && <ModificarModal onAccept={() => handleClickVisita(row, false)} />}

            {["Liberada"].includes(row.estado) && !!datosCabecera?.puedeModificar && dentroDelPlazoGestion && <AnularModal idVisita={row?.idVisita} reload={reload} />}
            
            {row.estado === "No Liberada" && !!datosCabecera?.puedeGestionar && dentroDelPlazoGestion && <ValidarModal reload={reload} visita={row} idTipoProfesional={idTipoProfesional} />}
            
            {puedeVerNovedades(row) && <div aria-hidden='true' onClick={() => handleOpenNovedadesModal(row.idVisita)} className='item-option clickable-option'>
              <CommentIcon className='edit-icon' />
              <span className='toggle-action'>Novedades</span>
            </div>}
          </div>
        </PopoverModal>
      </>;
    }
  };

  const getActionColumn = (puedeModificar, puedeGestionar) => {
    //TODO acciones por rol
    return actionColumn;
  };

  const initialColumns = useMemo(() => {
    const actionColumnAux = getActionColumn(datosCabecera?.puedeModificar, datosCabecera?.puedeGestionar);
    return [actionColumnAux, ...columnsBase];
  }, [datosCabecera?.puedeModificar, datosCabecera?.puedeGestionar, userLoggedMedicoONutri]);

  const columns = useMemo(() => {
    const parsedColumns = initialColumns.map((col) => {
      if (!isMobile) return { ...col };
      const { flex, ...rest } = col;
      return { ...rest };
    });

    return generateColumnsDefaultConfiguration(parsedColumns, isMobile);
  }, [datosCabecera?.puedeModificar, datosCabecera?.puedeGestionar, isMobile, userLoggedMedicoONutri]);

  return columns;
};